import React, { Component } from "react";
// import Joi from "joi-browser";
// import Input from "./input";
// import Select from "./select";
//import MessageCount from "./messageCount";
import TextareaAutosize from "react-textarea-autosize";
import { sclist } from "../../sc.json";
import { appendQuickReply } from "../../utils/quickReplies";

const getShortCodeTextClass = (shortCode) =>
  shortCode ? `row${shortCode}color` : "";

class TextArea extends Component {
  //inputReply = React.createRef();
  state = {
    message: "",
    dream: [],
    isFocuse: false,
  };


  getDefaultMessage = (dream) => {
    let defaultMessage = dream.MT_Arabic;
    const shortCode = String(dream.MOShortCode); // Ensure MOShortCode is a string




    if (["4022", "2337", "6877", "4142"].includes(shortCode) && !dream.isRedyToSent) {
      defaultMessage += `\n\n تنويه مهم: هذا الرقم للتفسير ${shortCode} أصبح قديماً، وتم استبداله برقم 7994 لتفسير الأحلام الجديدة، مع إضافة خدمة مميزة جداً وهي خدمة جديدة سريعة جداً عبر وتساب 0507354835 يصل التفسير الكتابي خلال أقل من ساعة، برسوم أوفر 25% مقارنة بالأس أم أس.`;
    } else if (["4024", "6055"].includes(shortCode) && !dream.isRedyToSent) {
      defaultMessage += `\n\n تنويه مهم: هذا الرقم للتفسير ${shortCode} أصبح قديماً، وتم استبداله برقم 7994 لتفسير الأحلام الجديدة، مع إضافة خدمة مميزة جداً وهي خدمة جديدة سريعة جداً عبر وتساب 0507354835 يصل التفسير الكتابي خلال أقل من ساعة، برسوم أوفر 25% مقارنة بالأس أم أس.`;
    } else if (["3900", "2304", "3772"].includes(shortCode) && !dream.isRedyToSent) {
      defaultMessage += "";
    }



    return defaultMessage;
  };

  getReplyMessageValue = (dream) => {
    if (dream.MT_Reply_Msg !== undefined && dream.MT_Reply_Msg !== null) {
      return dream.MT_Reply_Msg;
    }

    return this.getDefaultMessage(dream) || "";
  };


  handleChangeInputBlur =
    (dream) =>
      ({ currentTarget: input }) => {
        dream[input.name] = input.value;
        this.setState({ isFocuse: false });
        if (this.props.onChangeText) {
          this.props.onChangeText(dream, input.name, input.value);
        }
        //////console.log( "handleChangeInputBlur");
      };

  handleChangeInput =
    (dream) =>
      ({ currentTarget: input }) => {
        dream[input.name] = input.value;
        this.setState({
          dream: dream,
          isFocuse: true,
        });
        if (this.props.onChangeText) {
          this.props.onChangeText(dream, input.name, input.value);
        }
        //////console.log( "handleChangeInput");
      };

  handleChangeInput1 =
    (dream) =>
      ({ currentTarget: input }) => {
        //   //  if(input.value.length < 10){
        //   // return  toast.error("الرسالة أقل من 10 حروف ");
        //   //  }
        //////console.log( "handleChangeInput1");

        // dream[input.name]=input.value;
        dream[input.name] = input.value;
        this.setState({ dream: dream });

        this.props.onChangeText(dream, input.name, input.value);
      };

  handleChangeInputFocus =
    (dream) =>
      ({ target: input }) => {
        //this.inputReply.current.focus();

        dream[input.name] = input.value;
        this.setState({
          dream: dream,
          isFocuse: true,
        });
        //   //////console.log( "handleChangeInputFocus");
      };

  handleClickSend = (dream) => {
    dream["MT_Reply_Msg"] = dream["MT_Arabic"];
    this.props.onSendMsg(dream);
  };

  handleClickSave = (dream) => {
    this.props.onKeywordsMsg(dream);
  };

  handleUseQuickContactReply = (dream) => {
    const nextMessage = appendQuickReply(dream["MT_Reply_Msg"]);
    dream["MT_Reply_Msg"] = nextMessage;
    this.setState({
      dream: dream,
      isFocuse: true,
    });

    this.props.onChangeText(dream, "MT_Reply_Msg", nextMessage);
  };

  render() {
    const { dream, showHide, placeholderText, pcode, user } = this.props;
    const isReplyLockedByOther = dream.islock && user !== dream.Userlock && pcode !== 999;
    return showHide === false ? (
      <React.Fragment>
        {" "}
        <div className="row">
          <div className="col-12  col-lg-12  col-md-12 col-sm-12 text-right ">
            <div
              className={`text-right ${getShortCodeTextClass(
                dream.MOShortCode
              )}`}

            >
              <div dangerouslySetInnerHTML={{
                __html: dream.ReplyMsg4
              }}></div>
              <div style={{ float: "left" }}>
                {" "}
                <button
                  onClick={() => this.props.onGetAll(dream.MT_Mobil)}
                  className="btn text-right btn-light btn-sm"
                >
                  {" "}
                  {sclist.map((shortCode) => (
                    <React.Fragment key={shortCode.sc}>
                      <span className={`badge badge-${shortCode.sc}`}>
                        {
                          this.props.orginalDreams.filter(
                            (x) =>
                              x.MT_Mobil === dream.MT_Mobil &&
                              x.MOShortCode === shortCode.sc
                          ).length
                        }
                      </span>{" "}
                    </React.Fragment>
                  ))}


                  الرد
                </button>
              </div>
              &nbsp;&nbsp;
            </div>
            {pcode === 999 ? (
              <React.Fragment>
                <br />
                <div
                  className={`text-right ${getShortCodeTextClass(
                    dream.MOShortCode
                  )}`}
                >
                  {dream.MT_Arabic}
                </div>
                <button
                  onClick={() => this.handleClickSend(dream)}
                  className="btn text-right btn-success btn-sm"
                  disabled={this.state.disableSent}
                >
                  ارسال مباشر
                </button>
                <br />
                <br />
              </React.Fragment>
            ) : (
              ""
            )}

            <br />
          </div>
        </div>{" "}
      </React.Fragment>
    ) : (
      <div className="row">
        <div className="col-lg-8  col-md-12 col-sm-12 col-xs-12 text-right ">
          <div
            className={`text-right ${getShortCodeTextClass(
              dream.MOShortCode
            )}`}

          >
            <div dangerouslySetInnerHTML={{
              __html: this.props.htmlString
            }}></div>
          </div>

          {pcode === 999 ? (
            <React.Fragment>

              <div
                className={`text-right ${getShortCodeTextClass(
                  dream.MOShortCode
                )}`}
              >
                {dream.MT_Arabic}
              </div>
              <button
                onClick={() => this.handleClickSend(dream)}
                className="btn text-right btn-success btn-sm"
                disabled={this.state.disableSent}
              >
                ارسال مباشر
              </button>
              <br />
              <br />
            </React.Fragment>
          ) : (
            ""
          )}

          <br />
          {dream.islock && user !== dream.Userlock && pcode !== 999 ? (
            <TextareaAutosize
              minRows={4}
              className="form-control"
              style={{ direction: "rtl" }}
              rows={4}
              id={"MT_Reply_Msg" + dream.ReplyID}
              name="MT_Reply_Msg"
              onChange={this.handleChangeInput(dream)}
              onFocus={this.handleChangeInputFocus(dream)}
              onBlur={this.handleChangeInputBlur(dream)}
              value={this.getReplyMessageValue(dream)}

              disabled
              placeholder={placeholderText}
            //ref={this.inputReply}
            />
          ) : (
            <React.Fragment>
              <hr></hr>
              {dream.MufasserMsg}
              <hr></hr>
              <br />
              {dream.ReplyMsg2}
              <br />
              <br />
              <TextareaAutosize
                minRows={4}
                className="form-control"
                style={{ direction: "rtl" }}
                rows={4}
                id={"MT_Reply_Msg" + dream.ReplyID}
                name="MT_Reply_Msg"
                onChange={this.handleChangeInput(dream)}
                onFocus={this.handleChangeInputFocus(dream)}
                onBlur={this.handleChangeInputBlur(dream)}
                value={this.getReplyMessageValue(dream)}

                placeholder={placeholderText}

              //ref={this.inputReply}
              />
            </React.Fragment>

          )}
          {this.state.dream["ReplyID"] === dream.ReplyID ? (
            <div className="form-group">
              <span className="label label-primary">
                عدد الحروف{" "}
                {dream["MT_Reply_Msg"] ? dream["MT_Reply_Msg"].length : 0} - عدد
                الرسائل{" "}
                {dream["MT_Reply_Msg"] && dream["MT_Reply_Msg"].length < 71
                  ? 1
                  : Math.ceil(
                    dream["MT_Reply_Msg"]
                      ? dream["MT_Reply_Msg"].length / 63
                      : 0
                  )}
              </span>
            </div>
          ) : (
            ""
          )}
          {dream.islock && user === dream.Userlock ? (
            <button
              onClick={() => this.props.onSendMsg(dream)}
              className="btn text-right btn-success btn-sm"
            >
              ارسال
            </button>
          ) : (
            ""
          )}
          {pcode === 999 || !dream.islock ? (
            <button
              onClick={() => this.props.onSendMsg(dream)}
              className="btn text-right btn-success btn-sm"
            >
              ارسال
            </button>
          ) : (
            ""
          )}
        </div>

        <div className="col-lg-4  col-md-12 col-sm-12 col-xs-12 text-right ">
          <div style={{ margin: "2px", direction: "rtl" }}>
            {/* <img   src={require('../img/man.png')} alt="Fjords" style={{width:"40px" ,height:"50px"}} />
             <img   src={require('../img/woman.png')} alt="Fjords" style={{width:"40px" ,height:"50px"}} />
             <img   src={require('../img/unknown.png')} alt="Fjords" style={{width:"40px" ,height:"50px"}} /> */}
            <div>
              <button
                type="button"
                onClick={() => this.handleUseQuickContactReply(dream)}
                className="btn text-right btn-info btn-sm btn-block mb-2"
                disabled={isReplyLockedByOther}
                title="وضع نص التواصل داخل خانة الرد"
              >
                <i className="fa fa-commenting-o" aria-hidden="true" />{" "}
                نص التواصل
              </button>

              <TextareaAutosize
                minRows={3}
                className="form-control"
                rows={3}
                id={"personStatus" + dream.ReplyID}
                name="personStatus"
                onChange={this.handleChangeInput1(dream)}
                onBlur={this.handleChangeInputBlur(dream)}
                defaultValue={dream.PersonStatus}
                placeholder="اكتب هنا الحالة "
              //  ref={(input) => { this.nameInput = input; }}
              />

              {/* <div>
            <img  className="border border-success m-1"  src={require('../img/divorce.png')} alt="Fjords" style={{width:"40px" ,height:"50px"}} />
            <img className="border border-success"   src={require('../img/pragment2.png')} alt="Fjords" style={{width:"40px" ,height:"50px"}} />
            <img  className="border border-success  m-1"  src={require('../img/love.png')} alt="Fjords" style={{width:"40px" ,height:"50px"}} />
            <img className="border border-success"   src={require('../img/JOB.jpg')} alt="Fjords" style={{width:"40px" ,height:"50px"}} />
            <img className="border border-success m-1"   src={require('../img/nojob.jpg')} alt="Fjords" style={{width:"40px" ,height:"50px"}} />
            <img className="border border-success"   src={require('../img/sick2.png')} alt="Fjords" style={{width:"40px" ,height:"50px"}} />
            <img className="border border-success m-1"   src={require('../img/ritch.png')} alt="Fjords" style={{width:"40px" ,height:"50px"}} />
            <img className="border border-success"   src={require('../img/poor.png')} alt="Fjords" style={{width:"40px" ,height:"50px"}} />
            <img  className="border border-success m-1"  src={require('../img/problemsWith22.jpg')} alt="Fjords" style={{width:"40px" ,height:"50px"}} />
            <img className="border border-success"   src={require('../img/dipration.png')} alt="Fjords" style={{width:"40px" ,height:"50px"}} />
          
           </div> */}

              <TextareaAutosize
                minRows={2}
                className="form-control"
                rows={2}
                id={"MT_Englsih" + dream.ReplyID}
                name="MT_Englsih"
                onChange={this.handleChangeInput(dream)}
                onBlur={this.handleChangeInputBlur(dream)}
                //onFocus={this.handleChangeInput(dream)}
                defaultValue={dream.MT_Englsih}
                placeholder="اكتب هنا رموز الحلم "
              //  ref={(input) => { this.nameInput = input; }}
              />
            </div>

            <div>
              <button
                onClick={() => this.handleClickSave(dream)}
                className="btn text-right btn-primary btn-sm"
              >
                حفظ
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TextArea;



// WEBPACK FOOTER //
// ./src/components/common/textArea.jsx